import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  ApexChart,
  ApexFill,
  ApexLegend,
  ApexNonAxisChartSeries,
  ApexPlotOptions,
  ApexResponsive,
  ApexStroke,
  ApexTitleSubtitle,
  ApexYAxis,
  ChartComponent,
} from 'ng-apexcharts';

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  // labels: any;
  title: ApexTitleSubtitle;
  fill: ApexFill;
  yaxis: ApexYAxis;
  stroke: ApexStroke;
  legend: ApexLegend;
  plotOptions: ApexPlotOptions;
};

@Component({
  selector: 'app-pie',
  templateUrl: './pie.component.html',
  styleUrl: './pie.component.css',
})
export class PieComponent implements OnInit {
  @ViewChild('chart') chart: ChartComponent;
  public chartOptions: Partial<ChartOptions> | any;

  // Custom variables to plot chart
  @Input() customLabels: Partial<ChartOptions> | any ;
  @Input() customSeries: Partial<ChartOptions> | any ;

  ngOnInit(): void {
    this.chartOptions = {
      series: this.customSeries,
      chart: {
        width: 380,
        type: 'pie',
      },
      labels: this.customLabels,
      fill: {
        opacity: 1,
        colors: ['#0B41CD', '#4D75DD', '#9BB3EF'],
      },
      stroke: {
        width: 1,
        colors: ['#fff'],
      },
      yaxis: {
        show: false,
      },
      legend: {
        position: 'bottom',
      },
      plotOptions: {
        polarArea: {
          rings: {
            strokeWidth: 0,
          },
          spokes: {
            strokeWidth: 0,
          },
        },
      },
    };
  }

  public updateSeries() {
    this.chartOptions.labels = [
      this.customLabels,
      this.customSeries      
    ];
  }

}
